"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var auth_context_1 = require("../contexts/auth_context");
var queryString = "query ShowUser {\n    user {\n      id\n      isAdmin\n      isLabRat\n      firstName\n      lastName\n      email\n      personUuid\n      activeTeamCount\n      managedDivisionCount\n      managedTeamIds\n      uciUuid\n      roles {\n        id\n        type\n        scopeType\n        scopeId\n        organizationId\n        permissions\n      }\n      __typename\n    }\n  }\n";
var AuthWrapper = function (_a) {
    var authEndpoint = _a.authEndpoint, cogsworthUrl = _a.cogsworthUrl, clientId = _a.clientId, redirectUrl = _a.redirectUrl, children = _a.children, _b = _a.loadingIndicator, loadingIndicator = _b === void 0 ? 'Loading...' : _b;
    var _c = (0, auth_context_1.useAuthState)(), token = _c[0], updateToken = _c[1];
    var _d = react_1.default.useState(), user = _d[0], setUser = _d[1];
    var _e = react_1.default.useState(true), isLoading = _e[0], setIsLoading = _e[1];
    react_1.default.useEffect(function () {
        var redirectToLogin = function () {
            var redirect = redirectUrl || window.location.href;
            window.location.href = "".concat(cogsworthUrl, "login?client_id=").concat(clientId, "&redirect_uri=").concat(redirect);
        };
        fetch(authEndpoint, {
            credentials: 'include',
            cache: 'no-cache',
            method: 'POST',
            body: queryString,
        })
            .then(function (resp) {
            if (resp.ok) {
                resp
                    .json()
                    .then(function (json) {
                    if (!json.data.user) {
                        redirectToLogin();
                    }
                    setUser(json.data.user);
                    setIsLoading(false);
                })
                    .catch(function (err) {
                    redirectToLogin();
                });
            }
            else {
                redirectToLogin();
            }
        })
            .catch(function (e) {
            redirectToLogin();
        });
    }, [authEndpoint, clientId, cogsworthUrl, redirectUrl]);
    if (isLoading) {
        return react_1.default.createElement("div", null,
            loadingIndicator,
            " ");
    }
    return react_1.default.createElement(auth_context_1.AuthContext.Provider, { value: { user: user, token: token, updateToken: updateToken } }, children);
};
exports.default = AuthWrapper;
